import { css } from '@emotion/css';

export const backgroundNavbar = css`
  background-color: #222;
  font-size: 18px;
  font-family: 'Fuggles', cursive;
  max-width: 100%;
  behavior: smooth;
  scroll-behavior: smooth;
  box-shadow: 0 -8px -12px -10px rgb(18 18 18 / 60%);
  border-top:  5px rgb(18 18 18 / 60%);

  .logo{
    float: left;
    text-align: center;
    width: 100%;
  }

  .navbar-brand{
    padding-top:0;
    padding-bottom:0;
  }

  .navbar{
    padding-top:0px;
    padding-bottom:0px;
  }

  .nav-link {
    align-self: center;
  }
  .pojokKiri{
    font-family: 'Fuggles', cursive;
    font-size:35px;
    color:black;
    transition: font-size 0.2s;
  }


  .nav-item {
    align-self: center;
  }

  .nav-link {
    padding-left: 2rem !important;
  }
`;